module.exports = __webpack_public_path__ + "img/symbol_0.ca7406fc.png";